import { formSchema } from "../../validaciones/validacionPreferencias";
import { apiFetch } from "../../utils/api";

export const preferenciasSlice = (set,get) => ({
    insertarPreferencia: async () => {
        const result = formSchema.safeParse({ ...get().datos });
        if (!result.success) {
            console.log(result.error.errors);
            console.log(result.error.flatten().fieldErrors);
            set({error:result.error.flatten().fieldErrors})
            return;
        }
        else{
            set({error:null})
        }
        try {
            const datos = get().datos;
            const isNew = String(datos.id) === "0";
            const payload = {
                nombre: datos.nombre,
                branchIds: (datos.sucursales || []).map((item) => item.value).filter(Boolean),
                activo: Number(datos.estatus) === 1,
            };
            const data = await apiFetch(isNew ? "/api/preferences" : `/api/preferences/${datos.id}`,{
                method: isNew ? "POST" : "PUT",
                body: JSON.stringify(payload)
            });
            console.log('El dato',data);
            if(data.status){
                get().elNavigate(-1);
                get().limpiar();
            } else {
                window.notie?.alert({ type: 'warning', text: data.message || 'No se pudo guardar la preferencia' });
            }
        } catch (error) {
            console.log('Error',error);
            window.notie?.alert({ type: 'error', text: error.message || 'Error al guardar la preferencia' });
        }
    },
    obtenerPreferencia: async() => {
        if(String(get().datos.id) !== "0"){
            try {
                const data = await apiFetch(`/api/preferences/${get().datos.id}`,{
                    method: "GET",
                });
                if(data.status){
                   const branchIds = Array.isArray(data.data.branchIds) ? data.data.branchIds : [];
                   set({datos:{
                        ...get().datos,
                        nombre:data.data.nombre,
                        sucursales:get().sucursales.filter((item) => branchIds.includes(item.value)),
                        estatus:data.data.activo ? 1 : 2
                    }});
                }
            } catch (error) {
                console.log('Error',error);
            }
        }   
    }
})
